export default {
  xpFinalPosition: {},
  xpInitialPosition: {},
  goldInitialPosition:{},
  goldFinalPosition:{},
  isAnimationTrue: false,
  goldId: ''
};
